import { accessCriteria } from '../util/authorization/index';
import { authRoles } from './roleGroups';

const DOCUMENT_TITLE = 'Apportionment';

export const Apportionment = [
  {
    path: '/apportionment',
    name: 'Apportionment',
    meta: {
      title: DOCUMENT_TITLE,
    },
    component: () => import('../views/Apportionment.vue'),
    children: [
      {
        path: 'taxes',
        name: 'Tax - Apportionment - Taxes',
        meta: {
          title: DOCUMENT_TITLE,
        },
        component: () => import('../views/apportionment/Taxes.vue'),
      },
      {
        path: 'misc-mtg',
        name: 'Tax - Apportionment - Misc & Mtg',
        meta: {
          title: DOCUMENT_TITLE,
        },
        component: () => import('../views/apportionment/MiscMtg.vue'),
      },
      {
        path: 'apportionment',
        name: 'Tax - Apportionment - Apportionment',
        meta: {
          title: DOCUMENT_TITLE,
        },
        component: () => import('../views/apportionment/Apportionment.vue'),
      },
      {
        path: 'warrants',
        name: 'Tax - Apportionment - Remit Warrants',
        meta: {
          title: DOCUMENT_TITLE,
        },
        component: () => import('../views/apportionment/RemitWarrants.vue'),
      },
      {
        path: 'reports',
        name: 'Tax - Apportionment - Reports',
        meta: {
          title: DOCUMENT_TITLE,
        },
        component: () => import('../views/apportionment/Reports.vue'),
      },
      {
        path: 'utils',
        name: 'Tax - Apportionment - Utils',
        meta: {
          title: DOCUMENT_TITLE,
        },
        component: () => import('../views/apportionment/apportiomentsUtilsTab.vue'),
        children: [
          {
            path: 'appropriations',
            name: 'Tax - Apportionment - Appropriations',
            meta: {
              title: DOCUMENT_TITLE,
            },
            component: () => import('../views/apportionment/apportionmentUtils/appropriations.vue'),
          },
        ],
      },
    ],
  },
];

Apportionment.forEach((element, index) => {
  Apportionment[index].beforeEnter = async (to, from, next) => {
    await accessCriteria([...authRoles.TaxRead, ...authRoles.ApportionmentAuth], next);
  };
});

export default Apportionment;
